import { Icon } from '@acme/assets';
import { Link } from 'react-router-dom';

export const HelpSection = ({
  helpLinkPath: help,
  children,
}: {
  helpLinkPath: string;
  children: React.ReactNode;
}) => {
  return (
    <div className="flex w-full flex-col rounded-2xl border border-gray-200 p-4 gap-6 mt-4 font-inter font-medium leading-6">
      <Link
        className="flex items-center justify-between gap-3 text-gray-700 hover:text-brand-primary-default transition-colors"
        to={help}
      >
        <span className="flex-grow">Центр помощи</span>
        <Icon name="question-mark-outline" size={20} alt="Help" />
      </Link>
      {children}
    </div>
  );
};
